import {
    ExternalLinkInIframeHandlerBase,
    ExternalLinkInIframeRendererParams
} from "../external-link-in-iframe-handler-base";
import {CIPropRead} from "../../../../../utils/case-insensitive-property-reader";
import {ExternalLinksZIndexes} from "../../external-links-z-indexes";

export abstract class ForgotCredentialsExternalLinkHandlerBase extends ExternalLinkInIframeHandlerBase {
    protected async _onPostMessageReceived(message: MessageEvent): Promise<void> {
        const actionId = this._extractActionId(message);
        if(!actionId) {
            return;
        }

        switch (actionId) {
            case '3':
                if('close' === CIPropRead.getStringProperty('message', this._parseMessageData(message))?.toString()?.toLowerCase()) {
                    this._closeExternalLinkDialog();
                }
                break;
            case '73':
               await this._openLoginForm();
               break;
            case '77':
                await this._redirectToURL(message);
                break;
        }
    }

    protected async _openLoginForm(): Promise<void> {
        this._closeExternalLinkDialog();
        await this.services.user.openLogin();
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            maxWidth: 1008,
            maxHeight: 702,
            zIndex: ExternalLinksZIndexes.MyAccount,
            hideCloseButton: false,
            httpVerb: 'POST',
            analyticsAction: this._getGnwpSource()
        };
    }
}